import settings from "../../data/settings.json";

const { buildings } = settings;

const state = buildings.reduce((initialState, building) => {
	const db = require(`../../data/${building}.json`);
	initialState[building] = db.settings;
	return initialState;
}, {});

export default state;
